import { useMemo, useState } from 'react'

function readCollapsed(storageKey: string): string[] {
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(storageKey) || '[]')
    return Array.isArray(saved)
      ? [...new Set(saved.filter((value): value is string => typeof value === 'string' && value.length > 0))]
      : []
  } catch {
    return []
  }
}

/** Keep pane preferences across coins, view modes, and exchange selection changes. */
export function useChartCollapsePreference(orderStorageKey: string, controlled?: {
  collapsed: string[]
  onChange: (collapsed: string[]) => void
}) {
  const storageKey = `${orderStorageKey}:collapsed`
  const savedCollapsed = useMemo(() => readCollapsed(storageKey), [storageKey])
  const [preference, setPreference] = useState({ storageKey, collapsed: savedCollapsed })
  const collapsed = controlled?.collapsed ?? (preference.storageKey === storageKey ? preference.collapsed : savedCollapsed)

  const toggleChart = (chartId: string) => {
    const next = collapsed.includes(chartId)
      ? collapsed.filter((id) => id !== chartId)
      : [...collapsed, chartId]
    if (controlled) {
      controlled.onChange(next)
      return
    }
    setPreference({ storageKey, collapsed: next })
    try {
      localStorage.setItem(storageKey, JSON.stringify(next))
    } catch {
      // Charts still collapse when browser storage is unavailable.
    }
  }

  return { isCollapsed: (chartId: string) => collapsed.includes(chartId), toggleChart }
}
